module.exports = __webpack_public_path__ + "assets/logo-black@3x.45bf883f.png";